var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84 13.216A3.056 3.056 0 0 1 3.679 8l1.297-1.297.864.865-1.296 1.296a1.833 1.833 0 1 0 2.593 2.593l1.296-1.296.864.864L8 12.321a3.037 3.037 0 0 1-2.161.895zm.432-2.623-.864-.865 4.32-4.32.865.863-4.32 4.321h-.001zm4.754-1.297-.865-.864 1.296-1.296a1.833 1.833 0 1 0-2.592-2.593L7.568 5.84l-.864-.864L8 3.678A3.056 3.056 0 0 1 12.32 8l-1.295 1.296z",
    fill: "#007FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.35e72feb82dde2af1f6ab10fbc44b201.svg";
export { ForwardRef as ReactComponent };